import { render, staticRenderFns } from "./ConfirmAccessCode.vue?vue&type=template&id=fb89a852&scoped=true"
import script from "./ConfirmAccessCode.vue?vue&type=script&lang=js"
export * from "./ConfirmAccessCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb89a852",
  null
  
)

export default component.exports